﻿import { QueryClient } from '@tanstack/react-query'
import { useRealtimeService } from './realtimeService'
import { ReactElement } from 'react'

export function Realtime({ queryClient }: { readonly queryClient: QueryClient }): ReactElement {
    useRealtimeService(queryClient)
    return <></>
}
